import React, { useState, useCallback, useContext, useEffect, useMemo } from 'react'
import { GetInTouch } from '@/custom/components/molecules/GetInTouch'
import './OemDetails.css'
import { OverViewLayout } from './OverViewLayout'
import ProductLayout from './ProductLayout'

import 'slick-carousel/slick/slick-theme.css'
import { handleRedirectInternal, isValidHttpUrl } from '@/custom/common/components'
import Banner from '@/custom/components/molecules/Banner'
import CustomBanner from '@/custom/components/atoms/CustomBanner'
import * as Yup from 'yup'
import CommonFront from '@/custom/context/frontCommon/settingContext'
import { useFormik } from 'formik'
import Search from '../Search'
import { is } from 'date-fns/locale'
import { useHistory } from 'react-router-dom'
import { FALLBACK_IMAGE } from '@/utils'
import '../../views/HeaderPages/HeaderPage.css'
import CommonContext from '@/custom/context/common/commonContext'
import Skeletons from '@/custom/components/Skeletons'
import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
import { Button } from '@material-ui/core'

export const BrandDetails = () => {
    const [mainData, setMainData] = useState({
        bgColor: 'rgb(206, 65, 65)',
        textColor: 'rgb(206, 65, 65)',
    })
    const commonFront = useContext(CommonFront)
    const { table_data_store, searchTableBrandStore } = commonFront
    const [mainDataBrand, setMainDataBrand] = useState({})
    const [bannerData, setBannerData] = useState([])
    const commonContext = useContext(CommonContext)
    const [showAll, setShowAll] = useState(false)
    const { searchValue, allCategory, allOem, allbrand } = commonContext
    useEffect(() => {
        if (table_data_store) {
            if (table_data_store.from == 'searchTableBrandStore') {
                setBannerData(table_data_store.records.length ? table_data_store.records : [])
            }
        }
    }, [table_data_store])
    const history = useHistory()

    // Formik validation schema

    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'New Equipment', link: '/equipment/buy_new_equipment' },
        { label: 'Brands', link: '/allbrads' },
    ]

    const itemsToShow = useMemo(() => {
        const i = showAll ? allbrand : allbrand.filter((value) => value.priority > 50).slice(0, 9)

        return i
    }, [allbrand, showAll])

    return (
        <div className="oemDetalis">
            <div className=" getInTouchConts" style={mainData}>
                <section className="sectionContainer customContainer">
                    <div className="pb-3 pt-2">
                        <CustomBreadcrumbs items={breadcrumbs} />
                    </div>
                    <div className="childContainer">
                        <div className="childHeader d-flex justify-content-between align-items-center">
                            <h3 className="mb-0">Featured Brands</h3>
                        </div>
                        <div className="childGrid brandGrid mt-4">
                            {allOem.length === 0 ? (
                                [...Array(10)].map((_, index) => (
                                    <Skeletons key={index} type="box" />
                                ))
                            ) : (
                                <>
                                    {allOem.map((brand) => (
                                        <div key={brand.id}>
                                            <img
                                                onClick={() =>
                                                    handleRedirectInternal(
                                                        history,
                                                        `oem/${brand.id}/${brand.partner_company_id}`,
                                                    )
                                                }
                                                src={
                                                    brand && isValidHttpUrl(brand.company_logo)
                                                        ? brand.company_logo
                                                        : `${global.site_url}/uploads/users/${brand.company_logo}`
                                                }
                                                onError={(e) => FALLBACK_IMAGE(e)}
                                                alt={'loanImage'}
                                            />
                                        </div>
                                    ))}
                                </>
                            )}{' '}
                        </div>
                    </div>
                </section>
                <section className="sectionContainer customContainer">
                    <div className="childContainer AllBrandsContainer">
                        <div className="childHeader d-flex justify-content-between align-items-center">
                            <h3 className="mb-0">All Brands</h3>
                        </div>
                        <div className="childGrid brandGrid allBrands mt-4 mb-4">
                            {itemsToShow.length === 0 ? (
                                [...Array(10)].map((_, index) => (
                                    <Skeletons key={index} type="box" />
                                ))
                            ) : (
                                <>
                                    {itemsToShow.map((brand) => (
                                        <div>
                                            <img
                                                src={
                                                    brand && isValidHttpUrl(brand.brand_logo_image)
                                                        ? brand.brand_logo_image
                                                        : `${global.site_url}/uploads/brand/${brand.brand_logo_image}`
                                                }
                                                onError={(e) => FALLBACK_IMAGE(e)}
                                                alt={'loanImage'}
                                                onClick={() =>
                                                    handleRedirectInternal(
                                                        history,
                                                        `search?brand=${brand.id}&&is_new=1`,
                                                    )
                                                }
                                            />
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                        <div className="childFooter d-flex justify-content-center align-items-center">
                            <Button
                                className="custSecondaryButton w-auto"
                                onClick={() => setShowAll(!showAll)}
                            >
                                {showAll ? 'Show Less' : 'Load More'}
                            </Button>
                        </div>
                    </div>
                </section>
                <GetInTouch theme={mainData} />
            </div>
        </div>
    )
}
